import styled from "@emotion/styled/macro";
import {
  tokens,
  Typography,
  SvgIcon,
  SvgNames,
} from "@sunrun/experience-ui-components";

const NoImageMap = () => (
  <NoMap>
    <StyledIcon>
      <SvgIcon
        name={SvgNames.Redo}
        height={24}
        width={24}
        viewBox={"0 0 12 12"}
      />
    </StyledIcon>
    <Typography fontWeight="bold">No image</Typography>
    <Typography size="small">Pending site modeling info</Typography>
  </NoMap>
);

const StyledIcon = styled.div`
  margin: auto;
  width: fit-content;
`;

const NoMap = styled.div`
  width: 220px;
  height: 100px;
  background-color: ${tokens.BRAND_OFFWHITE};
  margin-left: auto;
  padding: 20px;
  align-items: center;
  box-sizing: border-box;
  > p {
    text-align: center;
  }
`;

export { NoImageMap };
